import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_ITEM_EXTERNAL_REFERENCE_COLLECTION_NAME =
  "price-list-item-external-reference";

export const useRxCollectionPriceListItemExternalReference =
  (): RxCollection<PriceListItemExternalReference> | null =>
    useRxCollection<PriceListItemExternalReference>(
      RXDB_PRICE_LIST_ITEM_EXTERNAL_REFERENCE_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<PriceListItemExternalReference>>;
export type PriceListItemExternalReferenceQueryConstructor = UseRxData["1"];

const PRICE_LIST_ITEM_EXTERNAL_REFERENCE_SCHEMA_LITERAL = {
  title: "price list item external reference schema",
  version: 1,
  description: "An external coding reference (e.g. CPT, ICD) for an item",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    itemId: {
      type: "string",
      maxLength: 100,
    },
    origin: {
      type: "string",
    },
    foreignId: {
      type: "string",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "itemId", "origin", "foreignId", "meta"],
  indexes: ["itemId"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(
  PRICE_LIST_ITEM_EXTERNAL_REFERENCE_SCHEMA_LITERAL,
);

export type PriceListItemExternalReference =
  ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const PRICE_LIST_ITEM_EXTERNAL_REFERENCE_SCHEMA: RxJsonSchema<PriceListItemExternalReference> =
  PRICE_LIST_ITEM_EXTERNAL_REFERENCE_SCHEMA_LITERAL;
